// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * APPEND-ONLY. The members below carry no explicit `= N`, so `FlatBuffers`
 * numbers them by declaration order and the ordinal IS the wire value.
 *
 * Inserting, reordering or removing a member silently renumbers every member
 * after it, which reinterprets every archived message and every frame in
 * flight — with no error anywhere, because the wire value stays a valid
 * member of the enum, just a different one. New values go LAST, always.
 */
export enum Usage {
  Up = 0,
  Down = 1,
  Forward = 2,
  Backward = 3,
  Parked = 4,
  NormalStopped = 5,
  FaultedStopped = 6,
  AboveDoorZone = 7,
  InDoorZone = 8,
  BelowDoorZone = 9,
  FrontDoorOpening = 10,
  FrontDoorClosing = 11,
  RearDoorOpening = 12,
  RearDoorClosing = 13,
  FrontDoorOpened = 14,
  FrontDoorClosed = 15,
  RearDoorOpened = 16,
  RearDoorClosed = 17,
  FrontDoorStalled = 18,
  RearDoorStalled = 19,
  Moving = 20,
  Levelling = 21,
  RunUp = 22,
  RunDown = 23,
  CodeBlueReturn = 24,
  DriveNotReady = 25,
  GripperFault = 26,
  IoError = 27,
  GateDoorLockFault = 28,
  WaitingForDoorClose = 29,
  WaitingForGateLock = 30,
  TopOfCarCommError = 31,
  DriveCommError = 32,
  DbResistorTemp = 33,
  CarToFloor = 34,
  NoSelectorInput = 35,
  InspectionBypassFault = 36,
  BinaryPositionError = 37,
  PositionError = 38,
  NoAutomaticDoors = 39,
  NoPotentialInput = 40,
  BrakeLiftSwitchError = 41,
  Shutdown = 42,
  SwingCar = 43,
  RearDoorOpenLimit = 44,
  CodeBlueUsage = 45,
  UpCallDoorFlag = 46,
  CarCallTime = 47,
  HallCallTime = 48,
  CarCallAbove = 49,
  CarCallBelow = 50,
  CarCallDisconnect = 51,
  HallCallDisconnect = 52,
  HoldInputAnsi = 53,
  CancelFrontUp = 54,
  CancelFrontDown = 55,
  DriveEnableUsage = 56,
  SwingingServiceUsage = 57,
  OverWeightBypass = 58,
  MedicalServiceUsage = 59,
  CancelRearUp = 60,
  AlarmBellUsage = 61,
  DoorZoneUsage = 62,
  CarCallEnable = 63,
  DoorOpenCommandUsage = 64,
  ShutdownUsage = 65,
  RearDoorCloseButtonUsage = 66,
  EmergencyPowerTest = 67,
  ShuntTripHeatDetector = 68,
  MedicalEmergencyCarSwitch = 69,
  MedicalEmergencyHallSwitch = 70,
  HospitalServiceDemanded = 71,
  CarCaptureSecurity = 72,
  OilTemperatureCold = 73,
  TelescopicResynchUsage = 74,
  UpSpeedLimitUsage = 75,
  HoistwayFrontGateClosed = 76,
  CarRearGateClosed = 77,
  AntiStallTimerUsage = 78,
  ApeHydroUsage = 79,
  BlockOperationUsage = 80,
  DemandDownUsage = 81,
  DemandUpUsage = 82,
  DeltaSimulationUsage = 83,
  DoorCloseCommandUsage = 84,
  DoorDisconnectSwitchUsage = 85,
  DoorEdgeFrontUsage = 86,
  DoorLockUsage = 87,
  DoorOpenButtonUsage = 88,
  DoorOpenLimitRearUsage = 89,
  DoorStuckUsage = 90,
  DownCallAboveUsage = 91,
  DownCallBelowUsage = 92,
  DownRunUsage = 93,
  DownSlowDownUsage = 94,
  DownStatusUsage = 95,
  EarthquakeInputUsage = 96,
  EmergencyMedicalTrip1Usage = 97,
  EmergencyMedicalTrip2Usage = 98,
  EmergencyPowerRunUsage = 99,
  EmergencyTripUsage = 100,
  EntrapmentUsage = 101,
  FastSpeedUsage = 102,
  FireServiceMainUsage = 103,
  FireServiceUsage = 104,
  FireServiceZoneUsage = 105,
  FireSmokeDetectorsBypassUsage = 106,
  HighSpeedUsage = 107,
  InServiceReadyUsage = 108,
  IndependentUsage = 109,
  LevelDownUsage = 110,
  LightLoadInputUsage = 111,
  MgRunOutputUsage = 112,
  MainLineDisconnectUsage = 113,
  MaxLoadUsage = 114,
  MechanicLeftSiteUsage = 115,
  MechanicOffsiteUsage = 116,
  MechanicOnsiteUsage = 117,
  MedicalServicePhase1Usage = 118,
  MedicalServicePhase2Usage = 119,
  MosLedIndicatorUsage = 120,
  MotorShutDownUsage = 121,
  NormalAutomaticOperationUsage = 122,
  OilTemperatureHighUsage = 123,
  OverTemperatureUsage = 124,
  PositionBottomUsage = 125,
  PositionTopUsage = 126,
  PressureSwitchUsage = 127,
  RearDoorCloseLimitUsage = 128,
  RearDoorOpenButtonUsage = 129,
  RearSafetyEdgeActivatedUsage = 130,
  RelevelingSpeedUsage = 131,
  RestrictedServiceUsage = 132,
  ReversalDeviceUsage = 133,
  SecurityUsage = 134,
  ShuntTripUsage = 135,
  SpareUsage = 136,
  UpCallAboveUsage = 137,
  UpCallBelowUsage = 138,
  UpLevelingUsage = 139,
  UpRunUsage = 140,
  UpSlowDownUsage = 141,
  UpStatusUsage = 142,
  UpTerminalSlowdownUsage = 143,
  WatchDogInputUsage = 144,
  YSimulationUsage = 145,
  M10CleanerUsage = 146,
  CodeBlueInCarOperationUsage = 147,
  AuxiliaryPowerShutDownUsage = 148,
  CarHasPowerToRunUsage = 149,
  HallCallRejectUsage = 150,
  HeartBeatUsage = 151,
  LobbyRecallUsage = 152,
  FireService1Usage = 153,
  CarToLobbyUsage = 154,
  HoldInputAnsiUsage = 155,
  InspectionServiceUsage = 156,
  PhaseOneFireServiceUsage = 157,
  FrontDoorInvalid = 158,
  RearDoorInvalid = 159,
  FrontDoorLocked = 160,
  FrontGateSwitch = 161,
  FrontDoorEdge = 162,
  RearDoorLocked = 163,
  RearGateSwitch = 164,
  RearDoorEdge = 165,
  FaultStopped = 166,
  Stopped = 167,
  Disconnected = 168,
  UpAssignedHallCall = 169,
  UpAssignedRearHallCall = 170,
  DownAssignedHallCall = 171,
  DownAssignedRearHallCall = 172,
  DoorOpenService = 173,
  RearDoorOpenDevice = 174,
}
